export const T = {
  accent: "#75c6fe",
  accentDark: "#3DAEE8",
  accentDeep: "#1a8ecb",
  accentLight: "#e8f6ff",
  accentMid: "#b8e3fd",
  bgPage: "#f7fbff",
  bgWhite: "#ffffff",
  bgSection: "#f0f7fe",
  border: "#ddeef9",
  borderMid: "#c5dff2",
  textHead: "#0c1f35",
  textBody: "#3a5a72",
  textMuted: "#8aa5bd",
  darkBg: "#0a0f1a",
  darkCard: "#131d2e",
  darkBorder: "rgba(255,255,255,0.08)",
  darkText: "#f0f4ff",
  darkMuted: "#7a8baa",
  green: "#34c98a",
  purple: "#7c6cf5",
  orange: "#f5924a",
  teal: "#28c4bc",
  pink: "#e96ba8",
  sky: "#49b6f5",
  fonts: {
    display: "'Special Gothic Expanded One', sans-serif",
    body: "'Lexend', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
};

export function rgba(hex, a) {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!r) return `rgba(117,198,254,${a})`;
  return `rgba(${parseInt(r[1], 16)},${parseInt(r[2], 16)},${parseInt(
    r[3],
    16
  )},${a})`;
}

export const features = [
  {
    id: "appointments",
    icon: "📅",
    color: T.accentDark,
    tag: "Scheduling",
    title: "Appointment Handling",
    shortDesc:
      "Smart scheduling with conflict detection, sync and automated reminders.",
  },
  {
    id: "queue",
    icon: "👥",
    color: T.green,
    tag: "Real-time",
    title: "Patient Queue Display",
    shortDesc: "Live queue visible clinic-wide — from check-in to discharge.",
  },
  {
    id: "invoicing",
    icon: "🧾",
    color: T.purple,
    tag: "Billing",
    title: "Digital Invoicing",
    shortDesc:
      "Generate professional invoices instantly and track all payments.",
  },
  {
    id: "patients",
    icon: "🐾",
    color: T.orange,
    tag: "Records",
    title: "Patient & Guardian Management",
    shortDesc:
      "Full medical history, vaccination records and guardian contacts.",
  },
  {
    id: "inventory",
    icon: "💊",
    color: T.teal,
    tag: "Stock Control",
    title: "Inventory & Pharmacy",
    shortDesc:
      "Stock monitoring, reorder alerts, expiry tracking and dispensing.",
  },
  {
    id: "sms",
    icon: "💬",
    color: T.pink,
    tag: "Communication",
    title: "SMS & Notifications",
    shortDesc:
      "Automated reminders, post-visit instructions and vaccine alerts.",
  },
  {
    id: "users",
    icon: "🔐",
    color: T.sky,
    tag: "Security",
    title: "Users & Permissions",
    shortDesc: "Role-based access for all staff with full audit logs.",
  },
];
